import { createFileRoute } from "@tanstack/react-router";
import { EditCookie, EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management/$cookieId/")({
  component: () => (
    <EditContent>
      <EditCookie />
    </EditContent>
  ),
});

export { Route };
